import type {AutocompleteItem} from '@mantine/core';
import {useEffect, useMemo, useState} from 'react';
import {
  getDepartmentsInSummary,
  useGetCompaniesInSummary,
} from '../../../core/repositories/reportSummaryRepository';

type Props = {
  reportType: string;
};

export const useHandleReportAnalyticsSearch = ({reportType}: Props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [searchWord, setSearchWord] = useState('');
  const [departmentItems, setDepartmentItems] = useState<
    Array<{id: number; name: string}>
  >([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState<
    string | undefined
  >(undefined);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState('0');

  useEffect(() => {
    if (selectedCompanyId) {
      void getDepartmentsInSummary({
        companyID: Number.parseInt(selectedCompanyId, 10),
        queryParams: {reportType},
      })
        .then((result) => {
          if (result.ok) {
            const departments = result.value.departments.map((department) => ({
              id: department.departmentID,
              name: department.departmentName,
            }));
            setDepartmentItems(departments);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [selectedCompanyId]);

  const {data} = useGetCompaniesInSummary({queryParams: {reportType}});

  const handleSearchInputChange = (searchWord: string) => {
    setSearchWord(searchWord);
  };

  const autoCompleteData: AutocompleteItem[] = data?.ok
    ? data.value.companies.map((company) => ({
        id: company.companyID,
        value: company.companyName,
      }))
    : [];

  const convertDepartmentItems = useMemo(() => {
    const defaultData = {
      value: '0',
      label: '--部門・職種を選択してください--',
    };

    return [
      defaultData,
      ...departmentItems.map((item) => {
        return {value: String(item.id), label: item.name};
      }),
    ];
  }, [departmentItems]);

  return {
    searchWord,
    autoCompleteData,
    handleSearchInputChange,
    convertDepartmentItems,
    selectedCompanyId,
    setSelectedCompanyId,
    selectedDepartmentId,
    setSelectedDepartmentId,
    setDepartmentItems,
  };
};
